import { render, staticRenderFns } from "./site-img.vue?vue&type=template&id=38197ac9&"
import script from "./site-img.vue?vue&type=script&lang=js&"
export * from "./site-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/UejMkTXs/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38197ac9')) {
      api.createRecord('38197ac9', component.options)
    } else {
      api.reload('38197ac9', component.options)
    }
    module.hot.accept("./site-img.vue?vue&type=template&id=38197ac9&", function () {
      api.rerender('38197ac9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/site-img.vue"
export default component.exports